import React from "react";

const inputLabel = ({ label, touched, error, customFeedbackLabel, customValidFeedbackLabel }) => {
  // Error
  if (touched && error) {
    return <div className="invalid-feedback">{error}</div>;
  }
  // Personalized message: Field successfully entered
  if(touched && !error && label && customValidFeedbackLabel){
    return <div className="valid-feedback">
      {customValidFeedbackLabel}
    </div>;
  }
  // This message is displayed in the component: Example: Please enter the field
  // Feedback not required for our purposes.
  return (
    <div className="feedback">
      {customFeedbackLabel && <>{customFeedbackLabel}</>}
    </div>
  );
};

const selectLabel = ({ label, touched, error, customFeedbackLabel }) => {
  if (touched && error) {
    return <div className="invalid-feedback">{error}</div>;
  }

  return (
    <div className="feedback">
      {customFeedbackLabel && <>{customFeedbackLabel}</>}
    </div>
  );
};

export function FieldFeedbackLabel({
  label,
  touched,
  error,
  type,
  customFeedbackLabel,
  customValidFeedbackLabel
}) {
  switch (type) {
    case "text":
      return inputLabel({ label, touched, error, customFeedbackLabel, customValidFeedbackLabel });
    case "number":
        return inputLabel({ label, touched, error, customFeedbackLabel, customValidFeedbackLabel });
    case "email":
      return inputLabel({ label, touched, error, customFeedbackLabel });
    case "password":
      return inputLabel({ label, touched, error, customFeedbackLabel });
    default:
      return selectLabel({ label, touched, error, customFeedbackLabel });
  }
}
